import { useEffect, useState } from "react";
import { useStore } from "../../state/state.ts";
import './input-plz.css'
import TextInput from "./input-text.tsx";

export default function PlzInput (props: {
  label?: string,
  value: number,
  placeholder?:number,
  disabled?: boolean,
  onChange: (value: string) => void,
  onBlur?: () => void,
}){
  const [valid, setValid] = useState(false);
  const api_check_zip = useStore((state)=>state.api_check_zip);
  const region_name = useStore((state)=>state.region_name);

  const validate = async (v:string)=>{
    const n = parseInt(v);
    return  n > 9999 && n <= 99999 && (await api_check_zip(n));
  };
 
  //console.log("plz", region_name);

  return <TextInput type="number" hint="Bitte eine gültige Postleitzahl z.B. 12345 eingeben." postfix={valid ? region_name : ""} label={props.label} value={props.value ? props.value.toString() : ""} placeholder={props.placeholder ? props.placeholder.toString() : ""} disabled={props.disabled}  onBlur={props.onBlur} onChange={(v)=>{
      props.onChange(Math.max(0, parseInt(v)));
    }} 
  validate={validate}
  onValidate={setValid}/>
}
